import type { ApiFieldError } from "@/types/api";
import { StudioApiError } from "@/types/api";

export function parseFieldErrorsFromApiData(
  code: string | undefined,
  data: unknown,
): ApiFieldError[] | undefined {
  if (code !== "INVALID_PARAM" || data == null || typeof data !== "object") {
    return undefined;
  }
  const errors = (data as { errors?: unknown }).errors;
  if (!Array.isArray(errors) || errors.length === 0) {
    return undefined;
  }
  const parsed: ApiFieldError[] = [];
  for (const item of errors) {
    if (
      item &&
      typeof item === "object" &&
      typeof (item as ApiFieldError).field === "string" &&
      typeof (item as ApiFieldError).message === "string"
    ) {
      parsed.push(item as ApiFieldError);
    }
  }
  return parsed.length > 0 ? parsed : undefined;
}

export function getFieldError(error: unknown, field: string): string | undefined {
  if (!(error instanceof StudioApiError) || !error.fieldErrors?.length) {
    return undefined;
  }
  return error.fieldErrors.find((e) => e.field === field)?.message;
}
